import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { addAchievmentsToState } from "../../redux";

import { useSetOrder } from "../../hooks/useSetOrder";
import { useFetchImage } from '../../hooks/useFetchImage';

import AlertMessage from '../../components/AlertMessage';

import "./style.css"

import icon_return from '../../assets/img/icon_return.png'

function ModalAchievments() {
    const dispatch = useDispatch();
    const setOrder = useSetOrder();
    const fetchImage = useFetchImage();

    const [categories_list, setCategories] = useState([]);
    const [achievments_list, setAchievments] = useState([]);

    const [alertMsg, setAlert] = useState([]);
    const [path, setPath] = useState(null);

    const categories_db = useSelector(state => state.data.categories);
    const achievments_db = useSelector(state => state.data.achievments);

    useEffect(() => {
        if (!categories_db) return
        setCategories([]);
        setAchievments([]);

        const fetchImages = async (datas, setList, type) => {
            let new_list = [];

            if (type === 'simple') {
                for (let data of datas) {
                    let new_data_list = { ...data }

                    if (data.image) {
                        const image = await fetchImage(data.image);
                        new_data_list.image = image;
                    }
                    new_list.push(new_data_list);
                }
            }

            if (type === 'multi') {
                for (let data of datas) {
                    let new_data_list = { ...data }

                    if (data.images.length !== 0) {
                        const image = await fetchImage(data.images[0]);
                        new_data_list.image = image;
                    }
                    new_list.push(new_data_list);
                }
            }
            setList(new_list);
        }

        const categories1 = categories_db.filter(cat => cat.type === 'prod' && (path ? cat.parentId === path : !cat.parentId));
        const categories2 = categories_db.filter(cat => cat.type === 'serv' && (path ? cat.parentId === path : !cat.parentId));
        const categories = [...categories1, ...categories2];

        if (categories.length !== 0 && !path) {
            fetchImages(categories, setCategories, 'simple');
            return
        }

        if (!path) return

        const achievments = achievments_db.filter(achiev => achiev.parentId === path);
        if (achievments.length !== 0) {
            fetchImages(achievments, setAchievments, 'multi');
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categories_db, achievments_db, path])

    const previous = () => {
        const parent = categories_db.find(cat => cat._id === path);
        setPath(parent.parentId);
    }

    const goTo = (_id) => {
        const childrens = achievments_db.filter(achiev => achiev.parentId === _id);
        if (childrens.length !== 0) setPath(_id);
    }

    const changePosPrev = async (achievment) => {
        if (achievment.order === 0) return;
    
        const prev_element = achievments_list.find(achiev => achiev.order === achievment.order - 1);
    
        if (!prev_element) {
            setAlert([...alertMsg, {
                title: `Erreur`,
                message: 'Contactez le développeur'
            }]);
            return;
        }
    
        const response = await setOrder('achievement', achievment._id, prev_element._id, setAlert);
        if (response !== true) return;
    
        const updatedAchievments_db = achievments_db.map(achiev => {
            if (achiev._id === achievment._id) {
                return { ...achiev, order: achiev.order - 1 };
            } 
            else if (achiev._id === prev_element._id) {
                return { ...achiev, order: achiev.order + 1 };
            }
            return achiev;
        });
        dispatch(addAchievmentsToState(updatedAchievments_db.sort((a, b) => a.order - b.order)));
    
        const updatedAchievments_list = achievments_list.map(achiev => {
            if (achiev._id === achievment._id) {
                return { ...achiev, order: achiev.order - 1 };
            } 
            else if (achiev._id === prev_element._id) {
                return { ...achiev, order: achiev.order + 1 };
            }
            return achiev;
        });
        setAchievments(updatedAchievments_list.sort((a, b) => a.order - b.order));
    }

    const changePosNext = async (achievment) => {
        if (achievment.order === achievments_list.length - 1) return;
    
        const next_element = achievments_list.find(achiev => achiev.order === achievment.order + 1);
    
        if (!next_element) {
            setAlert([...alertMsg, {
                title: `Erreur`,
                message: 'Contactez le développeur'
            }]);
            return;
        }
    
        const response = await setOrder('achievement', achievment._id, next_element._id, setAlert);
        if (response !== true) return;
    
        const updatedAchievments_db = achievments_db.map(achiev => {
            if (achiev._id === achievment._id) {
                return { ...achiev, order: achiev.order + 1 };
            } 
            else if (achiev._id === next_element._id) {
                return { ...achiev, order: achiev.order - 1 };
            }
            return achiev;
        });
        dispatch(addAchievmentsToState(updatedAchievments_db.sort((a, b) => a.order - b.order)));
    
        const updatedAchievments_list = achievments_list.map(achiev => {
            if (achiev._id === achievment._id) {
                return { ...achiev, order: achiev.order + 1 };
            } 
            else if (achiev._id === next_element._id) {
                return { ...achiev, order: achiev.order - 1 };
            }
            return achiev;
        });
        setAchievments(updatedAchievments_list.sort((a, b) => a.order - b.order));
    }

    return (
        <div className='modal modal_show modal_achievments'>
            <h1>Mes réalisations</h1>

            {categories_list.length !== 0 &&
                <ul className="categories_list_order">
                    {path &&
                        <li className="onglet_return_category">
                            <button
                                className='onglet_categories'
                                onClick={() => previous()}
                            >
                                <div className='preview'>
                                    <img
                                        src={icon_return}
                                        alt='Illustration'
                                    />
                                </div>

                                <span>Retour en arrière</span>
                            </button>
                        </li>
                    }

                    {categories_list.map((cat, idx) =>
                        <li className="ctn_onglet_category" key={idx}>
                            <button
                                className='onglet_categories'
                                onClick={() => goTo(cat._id)}
                            >
                                <div className='preview'>
                                    <img
                                        src={cat && cat.image && cat.image.image}
                                        alt='Illustration'
                                    />
                                </div>

                                <span>{cat.name_fr}</span>
                            </button>
                        </li>
                    )}
                </ul>
            }

            {achievments_list.length !== 0 &&
                <ul className="achievments_list_order">
                    {path &&
                        <li className="onglet_return_achievment">
                            <button
                                className='onglet_achievments'
                                onClick={() => previous()}
                            >
                                <div className='preview'>
                                    <img
                                        src={icon_return}
                                        alt='Illustration'
                                    />
                                </div>

                                <span>Retour en arrière</span>
                            </button>
                        </li>
                    }

                    {achievments_list.map((achiev, idx) =>
                        <li className="ctn_onglet_achievment" key={idx}>
                            <button
                                className="btn_prev"
                                onClick={() => changePosPrev(achiev)}
                            >
                                <i className="fas fa-chevron-left"></i>
                            </button>

                            <button className='onglet_achievments'>
                                <div className='preview'>
                                    <img
                                        src={achiev && achiev.image && achiev.image.image}
                                        alt='Illustration'
                                    />
                                </div>

                                <span>{achiev.name_fr}</span>
                            </button>
                            
                            <button
                                className="btn_next"
                                onClick={() => changePosNext(achiev)}
                            >
                                <i className="fas fa-chevron-right"></i>
                            </button>
                        </li>
                    )}
                </ul>
            }

            {alertMsg.length !== 0 && <AlertMessage alertMsg={alertMsg} setAlert={setAlert} />}
        </div>
    )
}

export default ModalAchievments;